import { Button } from "components/DesignSystem/Button/Button";
import Modal from "components/DesignSystem/Modal/Modal";
import { StatusModal } from "components/DesignSystem/StatusModal/StatusModal";
import { ModalProps } from "types/utils/modal";

export const ConfirmBulkTaskAdd = ({
  isOpen,
  close,
  isLoading,
  confirm,
  taskCount,
  itemCount,
}: ModalProps & {
  isLoading: boolean;
  confirm: () => void;
  taskCount: number;
  itemCount: number;
}) => {
  return (
    <Modal.Root open={isOpen} onOpenChange={close}>
      <Modal.Content size="small">
        <StatusModal type="warning" title="Confirm Bulk Action">
          <div className="t-text-body-sm t-text-text-30">
            You are about to perform the selected action(s) on {taskCount} tasks
            for {itemCount} companies in their cart. Are you sure you want to
            proceed?
          </div>
        </StatusModal>
        <Modal.FooterButtonGroup>
          <Modal.RawClose asChild>
            <Button>Go back</Button>
          </Modal.RawClose>
          <Button
            isLoading={isLoading}
            disabled={isLoading}
            customType="primary"
            onClick={confirm}
          >
            Yes, I confirm
          </Button>
        </Modal.FooterButtonGroup>
      </Modal.Content>
    </Modal.Root>
  );
};
